// extracted by mini-css-extract-plugin
export default {"botao":"BotaoWhatsApp_botao__BfZgW"};